module.exports = {
          srcSet: __webpack_public_path__ + "/assets/353abfd0039d508d42ce6d3f4ad9a010-320.jpg"+" 320w"+","+__webpack_public_path__ + "/assets/aa118038126a2878987447be5c9632d8-400.jpg"+" 400w",
          images:[ {path: __webpack_public_path__ + "/assets/353abfd0039d508d42ce6d3f4ad9a010-320.jpg",width: 320,height: 320},{path: __webpack_public_path__ + "/assets/aa118038126a2878987447be5c9632d8-400.jpg",width: 400,height: 400}],
          src: __webpack_public_path__ + "/assets/353abfd0039d508d42ce6d3f4ad9a010-320.jpg",
          toString:function(){return __webpack_public_path__ + "/assets/353abfd0039d508d42ce6d3f4ad9a010-320.jpg"},
          
          width: 320,
          height: 320
        }